import { render, staticRenderFns } from "./tcolumnarChart.vue?vue&type=template&id=45d110c0&scoped=true"
import script from "./tcolumnarChart.vue?vue&type=script&lang=js"
export * from "./tcolumnarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d110c0",
  null
  
)

export default component.exports